import React from 'react';

const BusinessUnitConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/organizationalsetup/businessunit',
			component:React.lazy(() => import('./BusinessUnit')) 
        }
	]
};

export default BusinessUnitConfig;